import { Injectable, Optional, SkipSelf } from '@angular/core';
import {
  CanActivate, CanActivateChild, Router,
  ActivatedRouteSnapshot,
  RouterStateSnapshot,
  CanLoad
} from '@angular/router';
import { AuthService } from '../services';

@Injectable({
  providedIn: 'root'
})
export class NoAuthGuard implements CanActivate, CanActivateChild, CanLoad {

  constructor(private router: Router, @Optional() private auth: AuthService) { }

  async canActivate(route: ActivatedRouteSnapshot, state: RouterStateSnapshot): Promise<boolean> {
    const user = await this.auth.authenticated();
    if (user && (user.id || user._id)) {
      this.router.navigate(['/dashboard']);
      return false;
    }
    return true;
  }

  canActivateChild(route: ActivatedRouteSnapshot, state: RouterStateSnapshot): Promise<boolean> {
    return this.canActivate(route, state);
  }

  async canLoad(): Promise<boolean> {
    const user = await this.auth.authenticated();
    if (user && (user.id || user._id)) {
      return false;
    }
    return true;
  }

}
